import {Card, Icon, Text, Progress, Label} from '@gravity-ui/uikit';
import styles from './AmountCard.module.scss';
import {Flame, Pencil} from '@gravity-ui/icons';
import {FundraiserFinanceModel, FundraiserDetailedModel} from '../../model';
import {formatCurrency} from '../../../../shared';
import {getStatusLabel} from '../../lib';
import {formatDate} from 'date-fns';
import React, {useState} from 'react';
import {EditFundraiserFinanceModal} from '../../../../features';

interface AmountCardProps {
  financeData?: FundraiserFinanceModel;
  fundraiserData?: FundraiserDetailedModel;
}

export const AmountCard = ({financeData, fundraiserData}: AmountCardProps) => {
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);

  // Вычисляем процент достижения цели
  const calculateProgress = () => {
    if (!financeData) return 0;
    if (!financeData.requiredAmount) return 100; // Если нет цели, то 100%
    return Math.min((financeData.collectedAmount / financeData.requiredAmount) * 100, 100);
  };

  const progressValue = calculateProgress();

  const handleEditClick = () => {
    setIsEditModalOpen(true);
  };

  return (
    <>
      <Card className={styles.card} type="action" size="l">
        <div className={styles.infoRow}>
          <Text variant={'subheader-2'}>Сумма и дата сбора</Text>
          <div onClick={handleEditClick} style={{cursor: 'pointer'}}>
            <Icon data={Pencil} />
          </div>
        </div>

        <div className={styles.infoRow}>
          <Text variant={'body-1'}>{formatCurrency(financeData?.collectedAmount)}</Text>
          {financeData?.requiredAmount && (
            <Text variant={'body-1'}> из {formatCurrency(financeData.requiredAmount)}</Text>
          )}
        </div>

        {/* Прогресс-бар */}
        <Progress value={progressValue} theme="info" size="s" className={styles.progress} />

        {/* Лейблы статуса и срочности */}
        <div className={styles.labelsRow}>
          {fundraiserData?.status && getStatusLabel(fundraiserData.status)}
          {fundraiserData?.isUrgent && (
            <Label theme="warning" icon={<Icon data={Flame} width={12} height={12} />}>
              Срочный
            </Label>
          )}
        </div>

        <div>
          <div className={styles.infoRow}>
            <Text variant={'subheader-1'}>Комиссия проекта:</Text>
            <Text variant={'body-1'}>{financeData?.commissionPercentage}%</Text>
          </div>

          {fundraiserData?.publishedAt && (
            <div className={styles.infoRow}>
              <Text variant={'subheader-1'}>Дата публикации:</Text>
              <Text variant={'body-1'}>{formatDate(new Date(fundraiserData.publishedAt), 'dd.MM.yyyy')}</Text>
            </div>
          )}

          {financeData?.end && (
            <div className={styles.infoRow}>
              <Text variant={'subheader-1'}>Дата завершения:</Text>
              <Text variant={'body-1'}>{formatDate(new Date(financeData.end), 'dd.MM.yyyy')}</Text>
            </div>
          )}
        </div>
      </Card>

      {/* Модалка редактирования финансов */}
      {fundraiserData?.id && (
        <EditFundraiserFinanceModal
          open={isEditModalOpen}
          setOpen={setIsEditModalOpen}
          fundraiserId={fundraiserData.id}
          financeData={financeData}
        />
      )}
    </>
  );
};
